import * as sha512 from "js-sha512";

const SALT_LENGTH = 64;
const SALT_CHARACTERS =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789~`!@#$%^&*()-_=+[{]}|;:'\",<.>/?";

export function generateSalt() {
  let salt = "";

  for (let i = 0; i < SALT_LENGTH; i++) {
    salt += SALT_CHARACTERS.charAt(
      Math.floor(Math.random() * SALT_CHARACTERS.length)
    );
  }

  return salt;
}

export function hashPassword(password: string) {
  const salt = generateSalt();
  const passwordWithSalt = password + "" + salt;
  const passwordHashHex = sha512.sha512.hex(passwordWithSalt).toUpperCase();

  return {
    salt,
    passwordHashHex
  }
}
